import { render } from "./GoldenOaksApp.vue?vue&type=template&id=825b61cc"
import script from "./GoldenOaksApp.vue?vue&type=script&lang=js"
export * from "./GoldenOaksApp.vue?vue&type=script&lang=js"

import "./GoldenOaksApp.vue?vue&type=style&index=0&id=825b61cc&lang=css"
import "./GoldenOaksApp.vue?vue&type=style&index=1&id=825b61cc&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__